import React, { Component } from "react";
import "../Styles/BrowserNotSupported.css";

class BrowserNotSupported extends Component {
    render() {
        return (
            <section className="fit layout vertical center-center browser-not-supported">
                <h2>Browser Not Supported</h2>
                <p>The browser you are currently using is not supported for this site.</p>
            </section>
        );
    }
}

export default BrowserNotSupported;
